"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _system = require("@mui/system");
var _Text = _interopRequireDefault(require("../../../../components/Text"));
var _Switch = _interopRequireDefault(require("../../../../components/Switch"));
var _AdjustmentRow = _interopRequireDefault(require("./../components/AdjustmentRow"));
var _SectionLine = _interopRequireDefault(require("./../components/SectionLine"));
var _i18n = _interopRequireDefault(require("../../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Block = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  paddingRight: 10
});
var styles = {
  adjustmentsHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  "switch": {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end"
  }
};

/**
 *
 * @param {*} param0
 * @returns
 */
var Adjustments = function Adjustments(_ref) {
  var invoice = _ref.invoice,
    isDivisionSummary = _ref.isDivisionSummary,
    blockMemberDetails = _ref.blockMemberDetails;
  /**
  * Checks if the invoice contains any adjustments with 0 as total, but is still in the adjustments object due to an added note etc.
  * 
  * @returns {boolean} Returns true if the invoice contains adjustments with non-zero total amounts, otherwise false.
  */
  var invoiceContainsNonZeroAdjustments = function invoiceContainsNonZeroAdjustments() {
    var _iterator = _createForOfIteratorHelper(invoice.adjustments),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var adjustment = _step.value;
        if (adjustment.amounts.totals.adjustments.total !== 0) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return false;
  };
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showAdjustments = _useState2[0],
    toggleAdjustments = _useState2[1];
  var hasNonZeroAdjustments = invoiceContainsNonZeroAdjustments();
  if (isDivisionSummary || blockMemberDetails) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(Block, null, /*#__PURE__*/_react["default"].createElement(_SectionLine["default"], null), invoice.adjustments.length === 0 || !hasNonZeroAdjustments ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    largest: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.invoices.adjustments)) : /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.adjustmentsHeader
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    largest: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.invoices.adjustments)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles["switch"]
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    light: true,
    customStyle: {
      marginBottom: 3,
      marginRight: 10
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.showDetailedAdjustments)), /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
    onChange: toggleAdjustments,
    checked: showAdjustments
  }))), showAdjustments && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, invoice.adjustments.length === 0 || !hasNonZeroAdjustments ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.invoices.noAdjustmentsSinceLastBilling)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      margin: "10px 0 20px 0"
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.changesSinceLastInvoice)), invoice.adjustments.map(function (adjustment, index) {
    return /*#__PURE__*/_react["default"].createElement(_AdjustmentRow["default"], {
      key: index,
      adjustment: adjustment
    });
  }))));
};
var _default = exports["default"] = Adjustments;